<template>
  <div id="ProjectFlow">
    <el-button type="primary" class="projectFlowBtn" @click="drawer=true" round>查看进度</el-button>
    <el-drawer title :visible.sync="drawer" :direction="'rtl'" :before-close="handleClose">
      <div>
        <div class="configRow">
          <el-button @click="goStepDetails" style="background-color:#f4a029">查看流程详情</el-button>
          <el-button @click="handleChangeStepDoitClick">调整流程节点</el-button>
        </div>
        <div class="selectionsBody">
          <el-timeline>
            <el-timeline-item
              placement="top"
              v-for="(activity, index) in projectFlowLog"
              :timestamp="activity.add_time"
              :stageCode="'11'"
              :key="index"
            >
              <el-card>
                <h4>
                  <span>{{activity.stage_code_show}}</span>
                  <!-- <span style="margin-left:20px" v-if="activity.approval_status=='0'">
                  <span v-for="item in activity.tomemberInfo">{{item.nickname}}</span>
                  </span>-->
                  <span
                    style="margin-left:20px"
                    v-if="activity.memberInfo"
                  >{{activity.memberInfo.nickname }}</span>
                  <span style="margin-left:20px" v-else>{{activity.memberInfo.nickname}}</span>

                  <!-- <span style="margin-left:20px">
                  <span style="color:rgb(240, 156, 10);" v-if="activity.approval_status=='0'">待审批</span>
                  <span style="color:rgb(14, 163, 232);" v-if="activity.approval_status=='1'">通过</span>
                  <span style="color:rgb(245, 95, 95);" v-if="activity.approval_status=='-1'">驳回</span>
                  <span v-if="activity.approval_status=='-2'">撤回</span>
                  </span>-->

                  <span style="margin-left:20px">
                    <span style="color:rgb(14, 163, 232);">提交</span>
                  </span>
                </h4>
                <!-- v-if="activity.approval_status!=0" -->
                <p style="margin-top:10px">
                  <span style="margin-right:10px" v-if="activity.approval_status == '0'">
                    <span v-for="itemsss in activity.tomemberInfo">{{itemsss.nickname}}</span>
                  </span>
                  <span
                    style="margin-right:10px"
                    v-if="activity.approval_status != '0'"
                  >{{activity.executorInfo.nickname }}</span>
                  <!-- <span style="color:rgb(14, 163, 232);" v-if="activity.approval_status=='1'">通过</span>
                <span style="color:rgb(245, 95, 95);" v-if="activity.approval_status=='-1'">驳回</span>
                  <span v-if="activity.approval_status=='-2'">撤回</span>-->

                  <span style="color:rgb(240, 156, 10);" v-if="activity.approval_status=='0'">待审批</span>
                  <span style="color:rgb(14, 163, 232);" v-if="activity.approval_status=='1'">通过</span>
                  <span style="color:rgb(245, 95, 95);" v-if="activity.approval_status=='-1'">驳回</span>
                  <span v-if="activity.approval_status=='-2'">撤回</span>
                  <span style="margin-left:10px">{{activity.update_time}}</span>
                </p>
                <p style="margin-top:10px" v-if="activity.remark">
                  <span style="margin-right:10px">{{'备注:'}}</span>
                  <span style="color:rgb(245, 95, 95);">{{activity.remark}}</span>
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
    <!-- <el-dialog
      :append-to-body="true"
      title="请选人员"
      :visible.sync="selectDia"
      width="40%"
      :before-close="handleClose"
      @close="handleClosed"
    >
      <div class="container"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectDia = false">取 消</el-button>
        <el-button type="primary" @click="getCheckedNodes">确 定</el-button>
      </span>
    </el-dialog>-->
    <!-- 项目进度弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleStep"
      width="60%"
      :before-close="handleStepClose"
      class="stepDia"
      @close="handleStepClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <!-- <span class="title-name" style="color:#128BF1;margin-right:5px">张某某-</span> -->
        <span class="title-age">调整项目节点</span>
      </div>
      <div class="stepChangeBox">
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box">
            <div style="box-sizing:border-box;padding:0">
              <!-- 项目名称 -->
              <el-form-item label="项目名称:" style="margin-bottom:0px;" v-if="projectName">
                <span style="color:#666;font-size:16px">{{projectName}}</span>
              </el-form-item>
              <!-- 公司名称 -->
              <el-form-item label="公司名称:" style="margin-bottom:0px;" v-if="companyName">
                <span style="color:#666;font-size:16px">{{companyName}}</span>
              </el-form-item>
              <!-- 调整项目阶段 -->
              <el-form-item label="调整项目节点:" style="margin-bottom:30px">
                <el-select style="width:70%" v-model="changeDoit" filterable placeholder="请选择">
                  <el-option
                    v-for="item in selectStepDoitList"
                    :key="item.k_code"
                    :label="item.label"
                    :value="item.k_code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="handlecancleClick">取 消</el-button>
        <el-button type="primary" @click="handleEditStepDoitSbumitClick">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer: false,
      member_id: '',
      company_id: '',
      token: '',
      details_project_status: '',
      details_project_id: '',
      selectStepDoitList: [],
      dialogVisibleStep: false,
      changeDoit: '',
      projectNameShow: '',
    }
  },
  props: [
    'projectFlowLog',
    'projectName',
    'projectId',
    'stageCode',
    'companyName',
  ],
  mounted() {
    console.log(
      'this.projectNamethis.projectNamethis.projectName',
      this.projectName
    )
  },
  watch: {
    projectName(val, oldVal) {
      //普通的watch监听
      if (val) {
        this.projectNameShow = val
        console.log(
          'this.projectNameShow12312313123this.projectNameShow',
          this.projectNameShow
        )
      }
    },
  },
  methods: {
    goStepDetails() {
      this.drawer = false
      this.$router.push({
        path: '/projectStep/step',
        query: {
          project_id: this.projectId,
          stage_code: this.stageCode,
        },
      })
    },
    handleChangeStepDoitClick() {
      this.dialogVisibleStep = true
    },
    async handleEditStepDoitSbumitClick() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('project_id', this.projectId)
      param.append('stage_code', this.stageCode)
      param.append('k_code', this.changeDoit)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/adjust_nodel',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisibleStep = false
      location.reload()
    },
    // 获取项目某个阶段可调整的节点
    async getAdjustListl() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('project_id', this.projectId)
      param.append('stage_code', this.stageCode)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/adjust_listl',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      res.datas.list.forEach((item, index) => {
        this.selectStepDoitList.push({ label: '', k_code: '' })
        item.forEach((items) => {
          this.selectStepDoitList[index].label += items.nickname + '/'
          this.selectStepDoitList[index].k_code = index
        })
        this.selectStepDoitList[index].label = this.selectStepDoitList[
          index
        ].label.substring(0, this.selectStepDoitList[index].label.length - 1)
      })
      console.log('this.selectStepDoitList', this.selectStepDoitList)
    },
    handleClose() {
      this.drawer = false
    },
    handleStepClose() {
      this.dialogVisibleStep = false
    },
    handleStepClosed() {
      this.changeDoit = ''
    },
    handlecancleClick() {
      this.dialogVisibleStep = false
    },
  },
  created: function () {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    if (this.projectId) {
      this.getAdjustListl()
    }
    console.log(
      'this.projectNamethis.projectNamethis.projectName',
      this.projectName
    )
  },
}
</script>
<style lang="less" scoped>
#ProjectFlow {
  display: flex;
  align-items: center;
  .projectFlowBtn {
    position: absolute;
    top: 0;
    right: 20px;
  }
}
#ProjectFlow {
  font-size: 14px;
  /deep/.el-drawer__body {
    padding: 0 25px;
    .selectionsBody {
      height: calc(100vh - 45px - 32px - 40px);
      overflow-y: auto;
    }
    .el-card__body {
    }
  }
}
.stepChangeBox {
  padding-top: 30px;
}
#ProjectFlow .filter-item-name {
  margin-right: 15px;
  text-align: right;
}
#ProjectFlow .filter-item-wrapper {
  display: flex;
  align-items: center;
}
#ProjectFlow .filter-dash-btn {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 234px;
  width: 100%;
  height: 40px;
  // border-radius: 4px;
  border: 1px solid #c9ccd8;
  color: #c9ccd8;
  cursor: pointer;
  transition: all 0.3s;
}
#ProjectFlow .filter-item-wrapper .filter-dash-btn:hover {
  border: 1px dashed #107fff;
}
#ProjectFlow .filter-tips-default {
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-left: 15px;
  align-items: center;
  width: 100%;
  height: 32px;
  transition: all 0.3s;
}
#ProjectFlow .filter-item-wrapper .filter-dash-btn:hover .filter-tips-default {
  color: #107fff;
}
.filter-checked-app {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  padding: 4px;
}
.checked-app-item {
  padding: 2px 6px;
  margin: 0 4px 0 0;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
}
.checked-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #ccc;
  transition: color 0.2s;
}
.checked-clear:hover {
  color: #aaa;
}

// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
/deep/ .el-dialog__header {
  padding: 16px 24px;
  color: #304265;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  .el-dialog__title {
    margin: 0;
    color: #304265;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
}
/deep/.el-dialog__body {
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
  .container {
    width: 100%;
    display: flex;
    .left {
      width: 55%;
      border-right: 1px solid #e8e8e8;
      box-sizing: border-box;
      .leftHead {
        display: flex;
        align-items: center;
        padding: 12px 24px;
        border-bottom: 1px solid #e8e8e8;
        i {
          color: #aaa;
        }
        // (deep)
        .el-input__inner {
          height: 22px;
          border: none;
          padding-left: 10px;
        }
      }
      .leftBody {
        box-sizing: border-box;
        padding-left: 10px;
        padding-top: 10px;
        height: 344px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
    .right {
      box-sizing: border-box;
      padding: 16px;
      width: 45%;
      height: 390px;
      overflow-x: hidden;
      overflow-y: scroll;
      .h3-organization-selected {
        position: relative;
        display: inline-block;
        background: #fafafa;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        padding: 0 24px 0 26px;
        margin: 0 8px 8px 0;
        height: 22px;
        max-width: 100%;
        .el-icon-user {
          left: 8px;
          margin-right: 6px;
          font-size: 12px;
          color: #bfbfbf;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
        }
        .el-icon-close {
          color: #bfbfbf;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
          width: 10px;
          height: 10px;
          font-size: 10px;
          margin-left: 8px;
          right: 8px;
        }
        .h3-organization-selected-name {
          display: inline-block;
          height: 100%;
          line-height: 1.5;
          max-width: 215px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.dialog-footer {
  width: 100%;
  display: flex;
  padding-left: 30%;
  .el-button {
    // width: 180px;
    width: 23%;
    height: 45px;
    padding: 0;
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    border: none;
    border-radius: 25px;
    background-color: #40a0f2;
    margin-bottom: 10px;
  }
  .el-button:first-child {
    margin-right: 5%;
  }
}
// 修改弹窗样式
.configRow {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-around;
  .el-button {
    font-size: 16px;
    font-weight: normal;
    border: none;
    width: 150px;
    height: 40px;
    background: rgb(64, 160, 242);
    color: #fff;
    border-radius: 24px;
    padding: 0;
    margin-left: 30px;
  }
}
/deep/.el-drawer__header {
  margin-bottom: 16px;
}
.diaForm_box {
  width: 100%;
  padding-left: 50px;
  box-sizing: border-box;
  /deep/.el-form-item__content {
    line-height: 36px;
  }
  /deep/.el-form-item__label {
    line-height: 36px;
    font-size: 16px;
    color: #333;
  }
  /deep/.labelFormItem {
    /deep/.ProjectType {
      width: 80%;
      flex-wrap: wrap;
      height: initial;
      max-height: 105px;
      overflow-y: auto;
      /deep/.el-radio {
        // width: 30%;
        height: 35px;
      }
      /deep/.el-checkbox {
        width: 20%;
        .el-checkbox__label {
          font-size: 16px;
          font-weight: normal;
        }
      }
    }
  }
  .inputTwoRow {
    box-sizing: border-box;
    // padding: 0 16%;
    // padding-right: 14%;
    width: 100%;
    display: flex;
    /deep/.el-form-item:nth-child(2) {
      margin-left: 10%;
    }
    /deep/.el-input__inner {
      width: 100%;
    }
  }
  .diaFormTitle {
    width: 100%;
    font-weight: bold;
    color: #128bf1;
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .diaFormTitle::before {
    content: '';
    display: block;
    width: 3px;
    height: 16px;
    background-color: #40a0f2;
    margin-right: 5px;
  }
  .diaFormTitle1 {
    width: 100%;
    font-weight: bold;
    color: #128bf1;
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .diaFormTitle1 span {
    display: flex;
    align-items: center;
  }
  .diaFormTitle1 span::before {
    content: '';
    display: block;
    width: 3px;
    height: 16px;
    background-color: #40a0f2;
    margin-right: 5px;
  }
}
/deep/.stepDia {
  margin-top: 10vh;
}
</style>